import Skeleton from "@mui/material/Skeleton";

import { Box, Typography, Grid, Button, Card, CardHeader, Avatar, CardContent } from "@mui/material";

export default function DummyTwitterCard(props) {
  const choicesMarkUp = [1, 1, 1, 1].map((row, idx) => {
    return (
      <Grid key={idx}>
        <Box margin="10px 0px">
          <Skeleton width="100%" variant="rectangular" style={{ borderRadius: "4px" }}>
            <Button>Loading choices ...</Button>
          </Skeleton>
        </Box>
      </Grid>
    );
  });

  const mainMarkup = (
    <Card>
      <CardHeader
        avatar={
          <Skeleton variant="circular">
            <Avatar />
          </Skeleton>
        }
        title={
          <Typography>
            <Skeleton width={100} />
          </Typography>
        }
      />
      <CardContent>
        <Typography variant="h5">
          <Skeleton width="60%" />
        </Typography>
        <Typography variant="h5">
          <Skeleton width="20%" />
        </Typography>
        {choicesMarkUp}{" "}
        <Box margin="10px 0px">
          <Typography variant="body2" color="textSecondary" component="p">
            <Skeleton width={144} />
          </Typography>
        </Box>
        <Box margin="20px 0px 0px 0px">
          <Typography variant="body2" color="textSecondary" component="p">
            <Skeleton width={200} />
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );

  return mainMarkup;
}
